import { Box } from '@mui/material';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import clsx from 'clsx';
import { getLocalTranslation } from '../../../utils/i18nKit';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var JoveQuoteUnconfirmedPaymentScheduleView = function JoveQuoteUnconfirmedPaymentScheduleView(props) {
  var className = props.className,
      list = props.list,
      displaySourceType = props.displaySourceType,
      hideEffectiveDateColumn = props.hideEffectiveDateColumn;

  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return (list === null || list === void 0 ? void 0 : list.length) > 0 ? /*#__PURE__*/_jsx(Box, {
    className: clsx('relative flex flex-col space-y-5', className),
    children: /*#__PURE__*/_jsxs(Table, {
      size: "small",
      className: "my-0",
      children: [/*#__PURE__*/_jsx(TableHead, {
        children: /*#__PURE__*/_jsxs(TableRow, {
          children: [/*#__PURE__*/_jsx(TableCell, {
            className: "bg-gray-100",
            padding: "none",
            align: "center",
            children: "Payment activity"
          }), !hideEffectiveDateColumn && /*#__PURE__*/_jsx(TableCell, {
            className: "bg-gray-100",
            padding: "none",
            align: "center",
            children: "Effective date"
          }), displaySourceType !== 'total_price' && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(TableCell, {
              className: "bg-gray-100",
              padding: "none",
              align: "center",
              children: $t('text:insurance_premium')
            }), /*#__PURE__*/_jsx(TableCell, {
              className: "bg-gray-100",
              padding: "none",
              align: "center",
              children: $t('text:insurance_premium_tax')
            }), /*#__PURE__*/_jsx(TableCell, {
              className: "bg-gray-100",
              padding: "none",
              align: "center",
              children: $t('text:admin_fee')
            }), /*#__PURE__*/_jsx(TableCell, {
              className: "bg-gray-100",
              padding: "none",
              align: "center",
              children: $t('text:processing_fee')
            })]
          }), /*#__PURE__*/_jsx(TableCell, {
            className: "bg-gray-100",
            padding: "none",
            align: "center",
            children: $t('kit:total')
          })]
        })
      }), /*#__PURE__*/_jsx(TableBody, {
        children: list.map(function (row, index) {
          return /*#__PURE__*/_jsxs(TableRow, {
            children: [/*#__PURE__*/_jsx(TableCell, {
              align: "center",
              children: row.paymentTypeText
            }), !hideEffectiveDateColumn && /*#__PURE__*/_jsx(TableCell, {
              align: "center",
              children: row.effectiveDateText
            }), displaySourceType !== 'total_price' && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(TableCell, {
                align: "center",
                children: row.priceText
              }), /*#__PURE__*/_jsx(TableCell, {
                align: "center",
                children: row.taxText
              }), /*#__PURE__*/_jsx(TableCell, {
                align: "center",
                children: row.adminFeeText
              }), /*#__PURE__*/_jsx(TableCell, {
                align: "center",
                children: row.processingFeeText
              })]
            }), /*#__PURE__*/_jsx(TableCell, {
              align: "center",
              children: row.totalText
            })]
          }, index);
        })
      })]
    })
  }) : null;
};